import React from "react";

import { SDUIComponentInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIButtonRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import * as styles from "@faire/retailer/components/SDUI/ComponentRenderers/Header/styles/SDUIHeaderRenderer.css";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";

export const SDUIHeaderRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  const headerComponent = component.header_component;
  if (!headerComponent) {
    return null;
  }
  const { tagline, title, sub_title, button_list } = headerComponent;
  return (
    <div className={styles.SDUIHeaderWrapper}>
      <div className={styles.SDUIHeaderMainContent}>
        {tagline ? (
          <SDUITypographyRenderer
            textElement={tagline}
            loggingData={loggingData}
          />
        ) : null}
        {title ? (
          <SDUITypographyRenderer
            textElement={title}
            loggingData={loggingData}
          />
        ) : null}
        {sub_title ? (
          <SDUITypographyRenderer
            textElement={sub_title}
            loggingData={loggingData}
          />
        ) : null}
      </div>
      {button_list.length > 0 ? (
        <div className={styles.SDUIHeaderButtonList}>
          {button_list.map((buttonElement, i) => (
            <SDUIButtonRenderer
              key={`${i}-${buttonElement.logging_data?.instance_identifier}`}
              loggingData={loggingData}
              buttonElement={buttonElement}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};
